import react, { useEffect, useState } from "react";
import { getSetting, useSetting } from '@app/hooks/user/mysetting.tsx';
import { SETTING_TYPE_SYSTEM } from '@app/constants/SETTING.tsx';
import { useFetcherPublic } from '@app/hooks/fetcher.tsx';

export const useCurrencyConverter = () => {
  const { data: setting } = useSetting(SETTING_TYPE_SYSTEM);
  const currency = getSetting(setting, "CURRENCY", "USD");
  const { data: currencyData } = useFetcherPublic("/system/currency");

  const [exchangeRate, setExchangeRate] = useState(1);

  useEffect(() => {
    if (currencyData?.result?.result) {
      const rate = currencyData.result.result.find(rate => rate.code === currency);
      setExchangeRate(rate ? parseFloat(rate.price) : 1);
      // console.log('currencyData', rate);

    }
  }, [currencyData, currency]);

  return (dollarPrice: number) => {
    if (isNaN(dollarPrice)) return 0;
    return parseFloat((dollarPrice * exchangeRate).toFixed(2));
  };
};